const tiposSolicitacoes = [
    {
        titulo: 'AUTORIZAÇÃO PARA ENVIO FORA DO PRAZO',
        tituloObjeto: 'Registro de Pagamento'
    }
]

export default tiposSolicitacoes
